import Form from 'components/Form';

import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: '尿毒症症狀，如噁心、嘔吐、食欲減退等',
    key: 'no3_1.checked1',
  },
  {
    label: '精神狀況惡化及腦病',
    key: 'no3_1.checked2',
  },
  {
    label: '心包炎',
    key: 'no3_1.checked3',
  },
  {
    label: '出血傾向',
    key: 'no3_1.checked4',
  },
  {
    label: '藥物無法控制的過量液體（如肺水腫）',
    key: 'no3_1.checked5',
  },
  {
    label: '代謝性酸中毒加重（少尿或無尿患者）',
    key: 'no3_1.checked6',
  },
];

const info = [
  { contents: '抗凝劑引起的出血傾向' },
  { contents: '低血壓' },
  { contents: '體溫過低' },
  { contents: '電解質及酸鹼平衡失調' },
];

const RecordInfo = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="3. 手術敘述" />
      <Box sx={{ margin: '48px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
            1) 手術目的與效果
          </Typography>
          {checks.map((v, i) => {
            return (
              <Grid item xs={11.5}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
          <Typography
            sx={{ fontSize: '14px', fontWeight: 500, marginTop: '10px' }}
          >
            2) 可能的副作用
          </Typography>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a.contents}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        <Typography
          sx={{ margin: '30px 0 20px 0', fontSize: '14px', fontWeight: 500 }}
        >
          患者的監護人已聽取並理解以上關於持續性腎臟替代治療的完整解釋，並同意確保患者的安全與治療。
        </Typography>
      </Box>
    </>
  );
};

export default RecordInfo;
